import { makeStyles, type Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(
  (theme) => ({
    root: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1.5,
      color: theme.palette.text.primary,
      wordBreak: 'break-word',
      whiteSpace: 'pre-line',
    },
  }),
  { name: 'VariationEditableContent' }
);
